import React from 'react';
import { Chart } from 'react-google-charts';
import InputMask from 'react-input-mask';
import { dateFormat } from '../../../../utils/format';
import { dateUnformat } from '../../../../utils/unformat';

export default function AttendancesChart({
    params, setParams, handleSubmit,
    handleClear, counts
}) {
    const data = counts;

    const options = {
        title: "Atendimentos Por Mês",
        vAxis: { minValue: 0 },
        chartArea: { left: 28, width: "80%", height: "70%" },
        pointSize: 5
    };

    function handleChange({ target: { name, value } }) {
        setParams(prevParams => ({
            ...prevParams,
            [name]: dateUnformat(value)
        }));
    }

    return (
        <div className="analitics-chart">
            <h3 style={{ marginBottom: '10px' }}>
                Atendimentos Concluídos Por Data
            </h3>
            <form className="chart-filter" onSubmit={handleSubmit}>
                <InputMask
                    name="begin_date"
                    mask="99/9999"
                    maskPlaceholder={null}
                    placeholder="Data Inicial"
                    onChange={handleChange}
                    value={dateFormat(params.begin_date)}
                    required
                />
                <InputMask
                    name="end_date"
                    mask="99/9999"
                    maskPlaceholder={null}
                    placeholder="Data Final"
                    onChange={handleChange}
                    value={dateFormat(params.end_date)}
                    required
                />
                <button className="btn-chart-filter">
                    <i className="fas fa-search"></i>
                </button>
                <button
                    type="button"
                    className="btn-chart-filter"
                    onClick={handleClear}
                >
                    <i className="fas fa-eraser"></i>
                </button>
            </form>
            <div className="analitics-chart-main">
                <Chart
                    chartType="AreaChart"
                    width="100%"
                    height="400px"
                    data={data}
                    options={options}
                    legendToggle
                />
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./resources/assets/js/pages/Site/AttendancesAnalysisPanel/components/AttendancesChart.js